'use strict';

const BaseForwardingAddressModalController=require('./baseForwardingAddressModalController');let

DeleteForwardingAddressModalController=class DeleteForwardingAddressModalController extends BaseForwardingAddressModalController{
static get $inject(){
return['$modalInstance','socketService','uiCommandFactory','onAddressListUpdated','notificationService','uncaughtErrorHandler','emailAddress'];
}

constructor($modalInstance,socketService,uiCommandFactory,onAddressListUpdated,notificationService,uncaughtErrorHandler,emailAddress){
super($modalInstance,socketService,uiCommandFactory,onAddressListUpdated,notificationService,uncaughtErrorHandler,emailAddress);
}

async onSubmissionSocketAction(){
return await this._socketService.sendAndWaitForResponse('DeleteNotificationForwardingAddress',this._emailAddress);
}};


module.exports=DeleteForwardingAddressModalController;
//# sourceMappingURL=deleteForwardingAddressModalController.js.map
